import interact from "interactjs";

function makeHeadRequest(url) {
    return fetch(url, { method: "HEAD" })
        .then((response) => (response.ok ? Promise.resolve(response) : Promise.reject(new Error("Request failed"))))
        .then((response) => response.headers);
}

async function getResourceContentLength(url) {
    let headers = await makeHeadRequest(url);
    let cl = headers.get("content-length");
    return cl;
}

/**
 * 
 * @async
 * 
 * @param {string} url 
 * @returns {Promise<{contentLength: string, duration: number, url: string}>}
 */
export async function getMetadata(url) {
    let contentLength = await getResourceContentLength(url);
    return new Promise((resolve) => {
        let video = document.createElement("video");
        video.addEventListener("loadedmetadata", function () {
            resolve({ contentLength, duration: video.duration, url });
        });
        video.src = url;
    });
}

export async function retrieveMetadata(...urls) {
    if (urls.length) {
        let promises = urls.map(getMetadata);
        let values = await Promise.allSettled(promises);
        return values;
    } else {
        return urls;
    }
}

/**
 * @typedef {Object} SimpleDraggableSquare
 * @property {string} name
 * @property {number} x
 * @property {number} y
 * @property {number} index
 * @property {HTMLElement} el
 * @property {string} url
 */

export class InteractGrid {

    /** @type {string | HTMLElement} */
    container = null
    /** @type {SimpleDraggableSquare[]} */
    draggableBlocks = []

    /**
     * 
     * @param {string | HTMLElement} container 
     */
    constructor(container) {
        if (!container) {
            throw new Error("Container must be initialized")
        }
        this.container = typeof container === 'string'
            ? document.querySelector(container)
            : container
    }

    /**
     * 
     * @param {number} x
     * @param {number} y
     * @param {(v: string, el: HTMLElement) => void} cb 
     * @returns {void}
     */
    addBlock(x = 0, y = 0, w = 80, h = 80, cb = null, url = '') {
        let __classContext = this
        let index = this.draggableBlocks.length
        let name = 'draggable' + index
        /** @type {HTMLElement} */
        let el = document.createElement('div')
        /** @type {HTMLButtonElement} */

        el.style.border = '2px dashed #000'
        el.style.width = `${w}px`
        el.style.height = `${h}px`
        el.style.position = 'absolute'
        el.style.top = `${y}px`
        el.style.left = `${x}px`
        el.classList.add('sel-area')

        
        el.setAttribute('data-name', name)
        el.setAttribute('data-index', index)

        // Register this object in the list of draggable objects
        this.draggableBlocks.push({
            index,
            name,
            el,
            x,
            y,
            url
        })
        // Append this object to this.container
        this.container.appendChild(el)

        interact(el)
            .draggable({
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: this.container
                    })
                ],
                listeners: {
                    move(event) {
                        let obj = __classContext.draggableBlocks[index]
                        obj.x += event.dx
                        obj.y += event.dy
                        event.target.style.top = obj.y + 'px'
                        event.target.style.left = obj.x + 'px'
                    }
                }
            })
            .resizable({
                edges: {
                    top: false,
                    left: false,
                    bottom: true,
                    right: true
                },
                listeners: {
                    move: function (ev) {
                        let { x, y } = ev.target.dataset

                        x = (parseFloat(x) || 0) + ev.deltaRect.left
                        y = (parseFloat(y) || 0) + ev.deltaRect.top

                        if (ev.rect.width <= 80 || ev.rect.height <= 80) {
                            return
                        }

                        Object.assign(ev.target.style, {
                            width: `${ev.rect.width}px`,
                            height: `${ev.rect.height}px`
                        })
                    }
                },
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: this.container
                    })
                ]
            })

        typeof cb === 'function' && cb(name, el, index)
    }

    /**
     * 
     * @param {number} blockIndex
     * @param {(v: string) => void} cb
     * @returns {boolean}
     */
    removeBlock(blockIndex, cb) {
        if (this.draggableBlocks[blockIndex]) {
            this.draggableBlocks[blockIndex].el.parentElement.removeChild(
                this.draggableBlocks[blockIndex].el
            )
            this.draggableBlocks.splice(blockIndex, 1)
            typeof cb === 'function' && cb(blockIndex)
            return true
        }
        return false
    }

    destroy() {
        this.draggableBlocks.forEach((_, idx) => {
            this.removeBlock(idx)
        })
        this.draggableBlocks = []
    }

    /**
     * @typedef {Object} DraggableObjectCords
     * @property {number} x1
     * @property {number} y1
     * @property {number} x2
     * @property {number} y2
     * @property {number} originParentWidth
     * @property {number} originParentHeight
     */

    /**
     * 
     * @param {HTMLElement?} referenceElement
     * @returns {DraggableObjectCords[]}
     */
    toObject(referenceElement = null) {
        let info = []
        let parentComputedStyles = window.getComputedStyle(referenceElement || this.container)
        let { width: originParentWidth, height: originParentHeight } = parentComputedStyles

        this.draggableBlocks.forEach((blockData) => {
            let compStyles = window.getComputedStyle(blockData.el)
            let { width, height } = compStyles
            width = parseFloat(width)
            height = parseFloat(height)
            console.log({url: blockData.url, blockData})
            info.push({
                x1: blockData.x,
                y1: blockData.y + height,
                x2: blockData.x + width,
                y2: blockData.y,
                originParentWidth: parseFloat(originParentWidth),
                originParentHeight: parseFloat(originParentHeight),
                url: blockData.url,
                testProp: 'hello, world'
            })
        })
        
        return info
    }
    
}